import { setUser } from '@sentry/react'
import { identifyDash0User } from './Dash0'

declare global {
  interface Window {
    // See https://help.ortto.com/tracking-code
    // Typed everything as optional to handle the case where the script is not loaded yet,
    // or it was blocked by an adblocker.
    ap3c?: {
      track?: (params: { v: 0; ei?: string; email?: string }) => void
      clearSession?: () => void
    }
  }
}

type IdentifyProps = {
  id?: string
  email?: string
}

/**
 * Identifies a user on Sentry and LogRocket
 */
export async function identifyUser({ id, email }: IdentifyProps): Promise<void> {
  const { default: LogRocket } = await import('logrocket')

  // LogRocket
  if (id && email) {
    LogRocket.identify(id, { email })
  } else if (id) {
    LogRocket.identify(id)
  } else if (email) {
    LogRocket.identify({ email })
  }

  // Sentry
  setUser({ id, email })

  // Dash0
  identifyDash0User(id, email)

  // Ortto
  window.ap3c?.track?.({ v: 0, ei: id, email })
}

/**
 * Removes users identification.
 * Note that LogRocket doesn't seem to support this.
 */
export async function removeUserIdentification(): Promise<void> {
  const { default: LogRocket } = await import('logrocket')
  LogRocket.identify({})
  setUser(null)

  // Ortto
  window.ap3c?.clearSession?.()
}
